import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../../components/shared/layout"
import SEO from "../../components/SEO/SEO"
import styled from "@emotion/styled"
import {
  featuredWrapper,
  noFeaturedWrapper,
  color,
  wrapper,
  breakpoints,
  ContentStyles,
  ContentStylesExt,
  wrapper1200,
} from "../../utils/style"
import Img from "gatsby-image"
import Breadcrumbs from "../../components/shared/Breadcrumbs"

const FeaturedWrapper = styled("div")`
  ${featuredWrapper}
  .gatsby-image-wrapper {
    border-radius: 24px;
  }
  img {
    border-radius: 24px;
  }
  .decorative-line {
    width: 288px;
    height: 2px;
    background: ${color.pink};
    margin: 20px 0;
  }
  @media (max-width: ${breakpoints.md}) {
    .gatsby-image-wrapper {
      border-radius: 10px;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .decorative-line {
      width: 100%;
      margin: 16px 0;
    }
  }
`

const NoFeaturedWrapper = styled("div")`
  ${noFeaturedWrapper}
  .decorative-line {
    width: 288px;
    height: 2px;
    background: ${color.pink};
    margin: 20px 0;
  }
  @media (max-width: ${breakpoints.sm}) {
    .decorative-line {
      width: 100%;
      margin: 16px 0;
    }
  }
`

const WrapperDesktop = styled("div")`
  ${wrapper1200}
`

const ContentWrapper = styled("div")`
  ${wrapper}
  ${ContentStyles}
  ${ContentStylesExt}
`

const PostContentWrapper = styled("div")`
  margin: 20px 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  a {
    display: flex;
    flex-basis: 49%;
    position: relative;
    margin: 10px 0;
    overflow: hidden;
    
    .image-wrap {
      flex-basis: 40%;
    }

    .text-part {
      flex-basis: 60%;
      padding: 0 20px;
    }

    .h5 {
      display: block;
      margin: 0;
      font-size: 18px;
      line-height: 24px;
    }
    
    .button {
      margin-top: 8px;
    }

    &:hover,
    &:active {
      text-decoration: none;
      color: ${color.white};
    }
    .gatsby-image-wrapper {
      height: 100%;
    }
  }

  @media (max-width: ${breakpoints.md}) {
    a {
      flex-basis: 100%;
    }
  }

  @media (max-width: ${breakpoints.sm}) {
    a {
      display: block;
      .text-part {
        padding: 16px 0;
      }
    }
  }
`

const NavLink = props => {
  if (!props.test) {
    return (
      <Link
        aria-label={"page " + props.text}
        className={`pagination ${props.className}`}
        to={props.url}
      >
        {props.text}
      </Link>
    )
  } else {
    return <span className={`pagination pagination-span ${props.className}`}>{props.text}</span>
  }
}

const PaginationHolder = styled("div")`
  flex-basis: 100%;
  margin-top: 20px;
  padding: 10px 0;
  margin-bottom: 38px;
  div,
  a,
  span {
    display: inline-block;
    vertical-align: top;
  }

  .pagination {
    margin: 3px;
    padding: 5px 7px;
    background-color: transparent;
    border: 2px solid ${color.white};
    border-radius: 4px;
    color: ${color.white};
    width: 38px;
    height: 38px;
    text-align: center;
    &.last-active {
      margin-right: 30px;
      position: relative;
      &:after {
        content: '...';
        font-size: 40px;
        line-height: 1;
        position: absolute;
        bottom: 0;
        right: -30px;
      }
    }
  }
  .pagination:hover,
  .pagination:active,
  .pagination-span {
    background-color: ${color.pink};
    border-color: ${color.pink};
    color: ${color.white};
    text-decoration: none;
  }

  .previousLink .pagination,
  .nextLink .pagination {
    height: 38px;
    width: 100px;
    position: relative;
    display: inline-block;
  }
  .previousLink .pagination::before {
    content: "";
    position: absolute;
    left: 0;
    top: 9px;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-right-color: ${color.white};
  }
  .nextLink .pagination::before {
    content: "";
    position: absolute;
    top: 9px;
    right: 0;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-left-color: ${color.white};
  }
`

const PaginatedPage = ({ data, pageContext }) => {
  const {
    group,
    index,
    first,
    last,
    pageCount,
    additionalContext,
  } = pageContext
  const checkIsCurrent = (edge, id) => {
    return edge.node.id === id
  }

  const currentCategoryArr = data.allWordpressCategory.edges.filter(edge =>
    checkIsCurrent(edge, additionalContext.id)
  )
  const currentCategory = currentCategoryArr[0].node
  const metaTitle =
    currentCategory.yoast_meta && currentCategory.yoast_meta.yoast_wpseo_title
      ? currentCategory.yoast_meta.yoast_wpseo_title
      : currentCategory.title + "- " + process.env.OWNER
  const metaDesc =
    currentCategory.yoast_meta &&
    currentCategory.yoast_meta.yoast_wpseo_metadesc
      ? currentCategory.yoast_meta.yoast_wpseo_metadesc
      : ""
  const breadcrumbs = pageContext.breadcrumbs
  const page_title = pageContext.page_title
  const previousUrl = index - 1 === 1 ? "" : (index - 1).toString()
  const nextUrl = (index + 1).toString()
  let seoBreadcrumbs = [...breadcrumbs]
  seoBreadcrumbs.push({ title: page_title })
  const clearedPath = currentCategory.path.replace("category/", "")

  const createPagination = (pagecount, index) => {
    let pages = []
    for (let i = 1; i <= pagecount; i++) {
      let page
      if (i === 1) {
        page = (
          <NavLink
            key={"blogUrl" + i}
            index={i}
            test={index === i}
            className="blogUrl"
            url={clearedPath}
            text={i}
          />
        )
      }
      if(pagecount >= 5) {
        if (i >= 2 && i <= 3 && index < 3) {
          page = (
            <NavLink
              key={"blogUrl" + i}
              index={i}
              test={index === i}
              className={`blogUrl ${(i === 3 && index !== 3) ? 'last-active' : ''}`}
              url={clearedPath + i + "/"}
              text={i}
            />
          )
        }
        if (i >= 2 && i <= 6 && index >= 3) {
          page = (
            <NavLink
              key={"blogUrl" + i}
              index={i}
              test={index === i}
              className={`blogUrl ${(i === 6 && index !== 6) ? 'last-active' : ''}`}
              url={clearedPath + i + "/"}
              text={i}
            />
          )
        }
        if (index === 6) {
          page = (
            <NavLink
              key={"blogUrl" + i}
              index={i}
              test={index === i}
              className={`blogUrl`}
              url={clearedPath + i + "/"}
              text={i}
            />
          )
        }
        if (i === pageCount) {
          page = (
            <NavLink
              key={"blogUrl" + i}
              index={i}
              test={index === i}
              className="blogUrl"
              url={clearedPath + i + "/"}
              text={i}
            />
          )
        }
      }
      else {
        page = (
          <NavLink
            key={"blogUrl" + i}
            index={i}
            test={index === i}
            className="blogUrl"
            url={clearedPath + i + "/"}
            text={i}
          />
        )
      }
      pages.push(page)
    }
    return pages
  }

  return (
    <Layout>
      <SEO
        title={metaTitle}
        description={metaDesc}
        pathname={currentCategory.path.replace("category/", "")}
        key="seo"
        breadcrumbs={seoBreadcrumbs}
      />
      <WrapperDesktop>
        <Breadcrumbs breadcrumbs={breadcrumbs} page_title={page_title} index={index} />
        {currentCategory.acf &&
        currentCategory.acf.category_image &&
        currentCategory.acf.category_image.localFile ? (
          <FeaturedWrapper key="featured-wrapper">
            <Img
              fluid={
                currentCategory.acf.category_image.localFile.childImageSharp
                  .fluid
              }
              alt={
                currentCategory.acf.category_image.alt_text
                  ? currentCategory.acf.category_image.alt_text
                  : currentCategory.name
              }
            />
            <h1 className="h1 rich-design" dangerouslySetInnerHTML={{ __html: currentCategory.name }} />
            <div className="decorative-line"/>
          </FeaturedWrapper>
        ) : (
          <NoFeaturedWrapper key="no-featured-wrapper">
            <h1 className="h1 rich-design" dangerouslySetInnerHTML={{ __html: currentCategory.name }} />
            <div className="decorative-line"/>
          </NoFeaturedWrapper>
        )}

        <PostContentWrapper key="content">
          {group.map(({ node }) => (
            <Link key={node.slug} to={"/" + node.slug + "/"}>
              <div className="image-wrap">
                {node.featured_media &&
                node.featured_media.localFile &&
                node.featured_media.localFile.childImageSharp &&
                node.featured_media.localFile.childImageSharp.fluid ? (
                  <Img
                    fluid={node.featured_media.localFile.childImageSharp.fluid}
                    alt={
                      node.featured_media.alt_text
                        ? node.featured_media.alt_text
                        : node.title
                    }
                  />
                ) : (
                  <Img
                    fluid={data.placeholder.childImageSharp.fluid}
                    alt={node?.title ? node.title : "แบนเนอร์ เว็บพนัน"}
                  />
                )}
              </div>
              <div className="text-part">
                <span className="h5">{node.title}</span>
                <div
                  className="excerpt"
                  dangerouslySetInnerHTML={{ __html: node.excerpt.slice(0, 250) + "..." }}
                />
                <span className="button white-button">
                  อ่านเพิ่มเติม
                </span>
              </div>
            </Link>
          ))}
        </PostContentWrapper>
        {pageCount > 1 && (
          <PaginationHolder>
            {index > 1 && (
              <div className="previousLink">
                <NavLink
                  test={first}
                  url={
                    currentCategory.path.replace("category/", "") +
                    previousUrl +
                    "/"
                  }
                  text="ก่อนหน้า"
                />
              </div>
            )}
            <div className="pageNumbers">
              {createPagination(pageCount, index)}
            </div>
            {index !== pageCount && (
              <div className="nextLink">
                <NavLink
                  test={last}
                  url={
                    currentCategory.path.replace("category/", "") + nextUrl + "/"
                  }
                  text="ถัดไป"
                />
              </div>
            )}
          </PaginationHolder>
        )}
        {currentCategory.description && (
          <ContentWrapper>
            <div
              dangerouslySetInnerHTML={{ __html: currentCategory.description }}
            />
          </ContentWrapper>
        )}
      </WrapperDesktop>
    </Layout>
  )
}
export default PaginatedPage

export const pageQuery = graphql`
  query($id: String) {
    allWordpressCategory(filter: { id: { eq: $id } }) {
      edges {
        node {
          id
          name
          slug
          description
          path
          link
          yoast_meta {
            yoast_wpseo_title
            yoast_wpseo_metadesc
          }
        }
      }
    }
    placeholder: file(relativePath: { eq: "placeholder.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 500) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
